/**
 * Short label for a healthcare professional type. Prefers the first alias,
 * which the professional type data defines as the display abbreviation
 * ("Physician", "CRNA", "LCSW"). `code` is deliberately not used: canonical
 * codes are identifiers such as PHYSICIAN and CLINICAL_SOCIAL_WORKER, not
 * labels. Rows without aliases fall back to the abbreviation embedded in
 * trailing parens of the name (e.g. "Doctor of Chiropractic (DC)"), then to the
 * full name.
 */
export function abbreviateProfessionalType(type: {
  name: string;
  aliases?: string[] | null;
}): string {
  const displayAbbreviation = type.aliases?.find(
    (alias) => alias.trim() !== "",
  );
  if (displayAbbreviation) {
    return displayAbbreviation;
  }

  return type.name.match(/\(([^)]+)\)\s*$/)?.[1] ?? type.name;
}
